/**
 * Stable integration point ids (wired once in code). Linked to super-admin features in AppFeatureIntegrations table.
 * Missing key in API integrations map = not configured = no gating.
 */
export const AppFeatureIntegration = {
  PortalMainProjectManagement: 'portal.main.project-management',
  PortalProjectAdmin: 'portal.project-admin',
  ApiCustomersProjectList: 'api.customers.project-list',
  ApiCustomerProjects: 'api.customer.projects',
} as const

export type AppFeatureIntegrationKey = (typeof AppFeatureIntegration)[keyof typeof AppFeatureIntegration]
